// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticketCreation {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  background: #f5f7fa;
  color: #333;
  overflow-y: hidden;
  letter-spacing: normal;
  min-height: 100vh;
}

/* Override internal col-md-6 inside FormikSelectField ONLY in this component */
.ticketCreation .col-md-6 {
  max-width: 33.333%;
}

/* Reduce spacing */
.ticketCreation .form-group {
  margin-bottom: 10px;
}

.attachments-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 10px;
}

.attachment-card {
    display: inline-flex;          /* auto width based on content */
    flex-direction: column;
    background: var(--color-bg-hover);
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    padding: 5px 10px;
    margin-right: 12px;
    margin-bottom: 12px;
    position: relative;
    max-width: 100%;               /* prevents overflow outside container */
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.attachment-info {
    padding-right: 30px; /* reserve space for delete icon */
    word-break: break-word; /* long file names wrap safely */
    white-space: normal;
}

.file-name {
    font-size: 13px;
    font-weight: 600;
    color:var(--color-primary-green);
    word-break: break-word;
}

.file-size {
    font-size: 11px;
    color: #777;    
    margin-top: 4px;
    margin-left:7px ;
}

.delete-icon {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 13px;
    color: red;
    cursor: pointer;
}

.dropzone {
    border: 2px dashed var(--color-primary-green);
    border-radius: 10px;
    padding: 25px;
    text-align: center;
    background: #f8f9ff;
    transition: 0.2s ease-in-out;
}

.dropzone:hover {
    background: #eef4ff;
    border-color:var(--color-primary-green);
}

.drag-text {
    font-size: 14px;  
    font-weight: 500;
}

.or-text {
    font-size: 12px;
    color: #777;
    margin: 5px 0 15px 0;
}

/* Hide dropdown by default */
.overflow-menu {
  display: none;
}

/* Show dropdown on hover */
.overflow-wrapper:hover .overflow-menu {
  display: block;
}
.workflow-nav-btn {
  background: transparent;
  color: #000;
  border: 1px solid var(--color-primary-orange);
  border-radius: 6px;
  padding: 6px 14px;
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/ticketcreation/components/TicketCreation.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB,WAAW,gCAAgC;IAC/D,sBAAsB;IACtB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe,gBAAgB,wCAAwC;IACvE,qCAAqC;AACzC;;AAEA;IACI,mBAAmB,EAAE,kCAAkC;IACvD,sBAAsB,EAAE,gCAAgC;IACxD,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".ticketCreation {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 14px;\n  background: #f5f7fa;\n  color: #333;\n  overflow-y: hidden;\n  letter-spacing: normal;\n  min-height: 100vh;\n}\n\n/* Override internal col-md-6 inside FormikSelectField ONLY in this component */\n.ticketCreation .col-md-6 {\n  max-width: 33.333%;\n}\n\n/* Reduce spacing */\n.ticketCreation .form-group {\n  margin-bottom: 10px;\n}\n\n.attachments-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 10px;\n}\n\n.attachment-card {\n    display: inline-flex;          /* auto width based on content */\n    flex-direction: column;\n    background: var(--color-bg-hover);\n    border: 1px solid #dcdcdc;\n    border-radius: 8px;\n    padding: 5px 10px;\n    margin-right: 12px;\n    margin-bottom: 12px;\n    position: relative;\n    max-width: 100%;               /* prevents overflow outside container */\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.attachment-info {\n    padding-right: 30px; /* reserve space for delete icon */\n    word-break: break-word; /* long file names wrap safely */\n    white-space: normal;\n}\n\n.file-name {\n    font-size: 13px;\n    font-weight: 600;\n    color:var(--color-primary-green);\n    word-break: break-word;\n}\n\n.file-size {\n    font-size: 11px;\n    color: #777;    \n    margin-top: 4px;\n    margin-left:7px ;\n}\n\n.delete-icon {\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    font-size: 13px;\n    color: red;\n    cursor: pointer;\n}\n\n.dropzone {\n    border: 2px dashed var(--color-primary-green);\n    border-radius: 10px;\n    padding: 25px;\n    text-align: center;\n    background: #f8f9ff;\n    transition: 0.2s ease-in-out;\n}\n\n.dropzone:hover {\n    background: #eef4ff;\n    border-color:var(--color-primary-green);\n}\n\n.drag-text {\n    font-size: 14px;  \n    font-weight: 500;\n}\n\n.or-text {\n    font-size: 12px;\n    color: #777;\n    margin: 5px 0 15px 0;\n}\n\n/* Hide dropdown by default */\n.overflow-menu {\n  display: none;\n}\n\n/* Show dropdown on hover */\n.overflow-wrapper:hover .overflow-menu {\n  display: block;\n}\n.workflow-nav-btn {\n  background: transparent;\n  color: #000;\n  border: 1px solid var(--color-primary-orange);\n  border-radius: 6px;\n  padding: 6px 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
